<div class="container-fluid">
  <div class="card-panel mt-5">
    <form [formGroup]="entidadeForm" autocomplete="off">
      <div class="row">
        <div class="col-md-8">
          <lib-page-header page-title="LIQUIDAÇÃO RESTOS A PAGAR"
            page-subtitle="EXERCÍCIO:  {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
            page-change="{{pagTitulo}}" show-change="true" image-title="assets/img/money5.png">
          </lib-page-header>
        </div>
        <div class="col-md-4">
          <a (click)="voltar()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </a>
          <a [routerLink]="['/liquidacoes-restos-pagar']" class="btn btn-sm btn-outline-secondary float-right ml-2">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
        </div>
      </div>
      <hr class="mt-0 mb-4" />
      <div class="row">
        <div class="col-md-8">
          <div class="row">
            <div class="col-9">
              <label class=" mr-2" style="font-weight: bold; color: #009688 ">EMPENHO Nº:</label>
              <label type="text" readonly id="numero_" style="font-size: 18px; font-weight: bold; color: #009688 ">{{
                ("00000" + entidadeForm.get('empenho.numero').value).slice(-5)
                }}/{{entidadeForm.get('empenho.ano').value}}
              </label>
              <label class="ml-2" style="font-size: 18px; font-weight: bold; color: #009688 "
                *ngIf="entidadeForm.get('parcela').value > 0">
                PARCELA: {{entidadeForm.get('parcela').value}}
              </label>
            </div>
            <div class="col-3">

            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-4">
              <label for="data_liquidacao">Data liquidacao</label>
              <input value="{{entidadeForm.get('data_liquidacao').value | date:'dd/MM/yyyy':'GMT'}}" type="text"
                class="form-control-plaintext" id="data_liquidacao">
            </div>
            <div class="form-group col-md-4">
              <label for="data_vencto">Vencimento</label>
              <input value="{{entidadeForm.get('data_vencimento').value | date:'dd/MM/yyyy':'GMT'}}" type="text"
                class="form-control-plaintext" id="data_vencto">
            </div>
            <div class="form-group col-md-4 pb-0 mb-0">
              <label for="valor_liquidado">Valor liquidado<span class="text-danger">*</span></label>
              <input unmask="true" [imask]="imaskConfig" formControlName="valor_liquidado" type="text"
                class="form-control-plaintext" id="valor_liquidado" readonly placeholder="informe o valor"
                style="font-weight: bold; color: #1e88e5">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-4">
              <label for="documento">N˚ Documento</label>
              <input value="{{entidadeForm.get('documento').value}}" type="text" class="form-control-plaintext"
                id="documento">
            </div>
          </div>
          <div class="form-row mb-0 pb-0">
            <div class="form-group col-12 pt-0 mt-0 mb-0 pb-0">
              <label for="favorecido">Favorecido</label>
              <input *ngIf="entidade.empenho"
                value="{{entidade.empenho.favorecido.cpf_cnpj | CPF}} {{entidade.empenho.favorecido.nome}}" readonly
                type="text" class="form-control-plaintext" id="favorecido">
            </div>
          </div>
          <div class="form-row pt-0 mt-0">
            <div class="form-group col-12 pt-0 mt-0">
              <input *ngIf="entidade.empenho" value="{{entidade.empenho.favorecido.endereco}}" readonly type="text"
                class="form-control-plaintext">
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-3 mb-2" />
      <div class="row">
        <div class="col-md-8">
          <div class="form-row  mb-0 pb-0">
            <div class="form-group col-12 mb-0 pb-0">
              <input *ngIf="entidade.empenho"
                value="{{entidade.empenho.subelemento}} {{entidade.empenho.subelemento_nome}}" readonly type="text"
                class="form-control-plaintext" id="ficha">
            </div>
          </div>
          <div class="form-row mt-0 pt-0">
            <div class="form-group col-12 mt-0 pt-0">
              <input *ngIf="entidade.empenho" value="{{entidade.empenho.acao}} {{entidade.empenho.acao_nome}}" readonly
                type="text" class="form-control-plaintext" id="ficha">
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-3 mb-2" />
      <div class="form-row">
        <div class="form-group col-12">
          <label for="historico">Histórico</label>
          <textarea formControlName="historico" readonly class="form-control-plaintext" id="historico"
            rows="5"></textarea>
        </div>
      </div>
    </form>
  </div>
</div>